import useSWR from 'swr';
import { fetcher } from '../services/fetcher';

export interface Task {
  taskId: number;
  clientId?: number;
  taskSubject: string;
  taskDescription?: string;
  taskStatus?: number;
  taskPriority?: number;
  taskDate?: string;
  taskCreatedAt: string;
  taskStatusDescr?: { ts_descr?: string };
}

export interface TasksResponse {
  data: Task[];
  total: number;
  page: number;
  limit: number;
}

export const useTasks = (searchParams?: string, filter?: string) => {
  const queryParams = new URLSearchParams();
  if (searchParams) queryParams.append('searchParams', searchParams);
  if (filter) queryParams.append('filter', filter);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

  const { data, error, isLoading, mutate } = useSWR<Task[]>(
    `/crm-tasks${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    tasks: data || [],
    total: data?.length || 0,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTask = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Task>(
    id ? `/crm-tasks/${id}` : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    task: data,
    isLoading,
    isError: error,
    mutate,
  };
};

